import { ActionHandler } from "..";
import { onStartSurvey } from "./onStartSurvey";
import getStore from "src/utils/redux/store";
import { trackBuyflowEvent } from "src/utils/api/tracker";
import { trackCurrentTierEvent } from "src/utils/counterOffer";
import { trackCancellationSurveyFinished } from "src/components/counter-offer/tracking";
import saveToBraze from "src/utils/brazeUploader";
import { resetCurrentAnswers } from "@utils/redux/slices/currentAnswers";
import { getPageSetSurvey } from "@pageDefinitions/actions/survey/util";

export const onStartCancellationSurvey: ActionHandler = (actionConfig) => {
  onStartSurvey(actionConfig);
  const store = getStore();
  const { serverContext } = store.getState();
  const survey = getPageSetSurvey(actionConfig.pageSet, actionConfig.page);
  const { surveyNameSpace } = survey;

  const eventData = {
    subscriptionId: serverContext.subscription_id,
    isOnInstallments: serverContext.is_on_installments,
    hasDiscount: !!serverContext.promo_code,
  };
  trackBuyflowEvent("CancellationSurveyStarted", eventData);
  saveToBraze({
    event: {
      event_name: "CancellationSurveyStarted",
      event_data: eventData,
    },
  });

  store.dispatch(
    resetCurrentAnswers({
      namespace: surveyNameSpace,
      answers: {},
    })
  );

  trackCurrentTierEvent();
};

export const onCompleteCancellationSurvey: ActionHandler = () => {
  trackCancellationSurveyFinished();
};
